import { getApiBaseUrl } from "../config/apiBase";
import { apiFetch } from "../config/apiFetch";
import type { GeoZone } from "../types";

async function parseError(res: Response): Promise<string> {
  const text = await res.text();
  try {
    const j = JSON.parse(text) as { error?: string };
    if (j.error) return j.error;
  } catch {
    /* ignore */
  }
  return text || `Request failed (${res.status})`;
}

export async function fetchGeoZones(): Promise<GeoZone[]> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/geo/zones`);
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<GeoZone[]>;
}

export async function createGeoZoneApi(input: { name: string; notes?: string }): Promise<GeoZone> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/geo/zones`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name: input.name, notes: input.notes ?? "" }),
  });
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<GeoZone>;
}

export async function updateGeoZoneApi(
  id: string,
  patch: Partial<
    Pick<GeoZone, "name" | "notes" | "districtKeys" | "mandalRefs" | "villageRefs" | "sortOrder">
  >,
): Promise<GeoZone> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/geo/zones/${encodeURIComponent(id)}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<GeoZone>;
}

export async function deleteGeoZoneApi(id: string): Promise<void> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/geo/zones/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
  if (!res.ok && res.status !== 204) throw new Error(await parseError(res));
}

export async function reorderGeoZones(orderedIds: string[]): Promise<GeoZone[]> {
  const res = await apiFetch(`${getApiBaseUrl()}/api/geo/zones/reorder`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ orderedIds }),
  });
  if (!res.ok) throw new Error(await parseError(res));
  return res.json() as Promise<GeoZone[]>;
}
